import { PaymentVendor, PaymentVendorAllowedCurrency } from 'checkout/enums/PaymentVendor';
import { IAvailablePaymentMethods } from 'checkout/types/PaymentMethod';

interface IGetRecommendedCurrencyParams {
  userLocation: string;
  userCurrency: string;
  paymentVendor: PaymentVendor;
  isOffer: boolean;
  isPaymentAvailabilityServiceEnabled?: boolean;
  availablePaymentMethods: IAvailablePaymentMethods;
}

const PaymentVendorsSupportAnyCurrency = new Set([
  PaymentVendor.CreditCard,
  PaymentVendor.ApplePay,
]);

const _newGetRecommendedCurrency = ({
  availablePaymentMethods,
  paymentVendor,
  userCurrency,
}: {
  availablePaymentMethods: IAvailablePaymentMethods;
  paymentVendor: PaymentVendor;
  userCurrency: string;
}) => {
  const isVendorSupportAnyCurrency = PaymentVendorsSupportAnyCurrency.has(paymentVendor);

  const recommendedCurrency =
    availablePaymentMethods[paymentVendor]?.supportedCurrencies[0] || 'USD';

  if (isVendorSupportAnyCurrency) return userCurrency;

  return recommendedCurrency;
};

const _oldGetRecommendedCurrency = ({ userLocation, userCurrency, paymentVendor, isOffer }) => {
  const isVendorSupportAnyCurrency = PaymentVendorsSupportAnyCurrency.has(paymentVendor);
  const supportedLocations = PaymentVendorAllowedCurrency[paymentVendor];
  const recommendedCurrency =
    supportedLocations?.[userLocation] || supportedLocations?.Other || 'USD';

  // Offers are always in USD.
  if (isOffer) return 'USD';

  // Payment Vendor handles all currencies.
  if (isVendorSupportAnyCurrency) return userCurrency;

  // Bypass Klarna because has its own recommendation logic in ChangeCurrencyKlarnaModal file.
  if (paymentVendor === PaymentVendor.Klarna) return userCurrency;

  return recommendedCurrency;
};

export const getRecommendedCurrency = ({
  userLocation,
  userCurrency,
  paymentVendor,
  isOffer,
  isPaymentAvailabilityServiceEnabled,
  availablePaymentMethods,
}: IGetRecommendedCurrencyParams) => {
  if (isPaymentAvailabilityServiceEnabled) {
    return _newGetRecommendedCurrency({ availablePaymentMethods, paymentVendor, userCurrency });
  }

  return _oldGetRecommendedCurrency({
    userLocation,
    userCurrency,
    paymentVendor,
    isOffer,
  });
};
